import { Injector } from "@angular/core";
import { Subscription } from "rxjs";

import { CerPromptService } from "@ui/cer-ui-prompt.service";

import { CerFormComponent } from "@form/cer-form.component";
import { CerFormService } from "@form/cer-form.service";
import { CerFormView } from "@form/cer-form-view";

import { CerAppRouteService } from "src/cer-app/cer-app-route/cer-app-route.service";
import { CerAppStateService } from "src/cer-app/cer-app-state/cer-app-state.service";
import { CerSessionService } from "@cer/cer-session/cer-session.service";

export class CerFormContext {
  public form: CerFormComponent;
  public formService: CerFormService;
  public routeService: CerAppRouteService;
  public ui: CerPromptService;
  public stateService: CerAppStateService;
  public session: CerSessionService;
  public injector: Injector;
  public subscriptionManager: Subscription;
  public parentView: CerFormView;
}
